import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Table, Button } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import renderRadioButtonField from '../../../../../shared/components/form/RadioButton';
import Modal from '../../../../../shared/components/Modal';

const renderField = ({
    input, placeholder, type, meta: { touched, error },
}) => (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
        <input {...input} placeholder={placeholder} type={type} />
        {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
);

renderField.propTypes = {
    input: PropTypes.shape().isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }),
};

renderField.defaultProps = {
    placeholder: '',
    meta: null,
    type: 'text',
};


class Criteria extends Component {
    constructor(props) {
        super(props);
        this.state = {
            enrolado: 'No',
            inclusion: [],
            exclusion: [],
            inclusionSend: [],
            exclusionSend: [],
            empty: false,
            load: true,
            openAlert: false,
            modalAlert: { message: '', color: '', title: '' },
        }
    }

    componentDidMount() {
        this.getCriteria();
    }

    handlerInclusion = (value, index) => {
        let inclusionNew = this.state.inclusion[index];

        if (value === "Sí")
            inclusionNew.confirmacion = true;
        else
            inclusionNew.confirmacion = false;

        this.state.inclusionSend.push(inclusionNew);

        console.log(inclusionNew);
    }

    handlerExclusion = (value, index) => {
        let exclusionNew = this.state.exclusion[index];

        if (value === "Sí")
            exclusionNew.confirmacion = true;
        else
            exclusionNew.confirmacion = false;

        this.state.exclusionSend.push(exclusionNew);

        console.log(exclusionNew);

    }

    saveCriterio = () => {

        let dataSend = {
            id_historia: this.props.id_historia,
            id_estudio: this.props.id_estudio,
            id_paciente: this.props.id_paciente,
            id_admision: this.props.id_admision,
            paciente_enrolado: true,
            inclusion: this.state.inclusionSend,
            exclusion: this.state.exclusionSend
        };

        console.log(dataSend);

        fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-estudio/save-criterios', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log(data);
                this.setState({
                    openAlert: true,
                    modalAlert: {
                        message: 'Guardado con exito',
                        color: 'success',
                        title: "Exito!"
                    }
                });

            })
            .catch((error) => {
                console.error('Error:', error);
                this.setState({
                    openAlert: true,
                    modalAlert: {
                        message: 'Se ha presentado un error al guardar',
                        color: 'danger',
                        title: "Error!"
                    }
                });
            });
    }

    getCriteria = () => {

        const dataSend = { id_visita: this.props.id_visita, id_estudio: this.props.id_estudio };

        fetch(process.env.REACT_APP_PUBLIC_URL + 'criteriose/consultar', { // revisar el servicio para que traiga confirmacion
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log(data);
                if (typeof data.contenido === 'string')
                    this.setState({ empty: true });
                else
                    this.setState({ inclusion: data.contenido.inclusion, exclusion: data.contenido.exclusion });

            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    handlerEnrolado = (enrolado) => {
        this.setState({ enrolado: enrolado });
    }

    render() {

        return (
            <Col>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>

                    <h5 className="bold-text">Criterios de Inclusión</h5>

                    {this.state.inclusion.length === 0 ? <h5> No se han agregado los criterios de Inclusión en este Estudio </h5> :
                        <Table bordered style={{ width: '60%', marginTop: 20 }}>
                            <thead>
                                <tr>
                                    <td>Item </td>
                                    <td >Criterio </td>
                                    <td >Confirmación </td>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.inclusion.map((data, index) => {
                                    return <tr key={index}>
                                        <td>{data.orden}</td>
                                        <td style={{ width: '70%' }}>{data.descripcion}</td>
                                        <td><Field
                                            name={`confirm-inclusion-${index}`}
                                            component={renderRadioButtonField}
                                            label="Sí"
                                            radioValue={"Sí"}
                                            //checked={this.state.inclusion[index].confirmacion}
                                            onChange={(e) => {
                                                this.handlerInclusion(e, index);

                                            }}
                                        />
                                            <Field
                                                name={`confirm-inclusion-${index}`}
                                                component={renderRadioButtonField}
                                                label="No"
                                                radioValue={"No"}
                                                onChange={(e) => {
                                                    this.handlerInclusion(e, index);
                                                }}
                                            /></td>
                                    </tr>
                                })
                                }
                            </tbody>
                        </Table>
                    }

                    <h5 className="bold-text">Criterios de Exclusión</h5>

                    {this.state.exclusion.length === 0 ? <h5> No se han agregado los criterios de Exclusión en este Estudio </h5> :
                        <Table bordered style={{ width: '60%', marginTop: 20 }}>
                            <thead>
                                <tr>
                                    <td>Item </td>
                                    <td >Criterio </td>
                                    <td >Confirmación </td>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.exclusion.map((data, index) => {
                                    return <tr key={index}>
                                        <td>{data.orden}</td>
                                        <td style={{ width: '70%' }}>{data.descripcion}</td>
                                        <td><Field
                                            name={`confirm-exclusion-${index}`}
                                            component={renderRadioButtonField}
                                            label="Sí"
                                            radioValue={"Sí"}
                                            onChange={(e) => {
                                                this.handlerExclusion(e, index);
                                            }}
                                        />
                                            <Field
                                                name={`confirm-exclusion-${index}`}
                                                component={renderRadioButtonField}
                                                label="No"
                                                radioValue={"No"}
                                                onChange={(e) => {
                                                    this.handlerExclusion(e, index)
                                                }}
                                            /></td>
                                    </tr>
                                })
                                }
                            </tbody>
                        </Table>
                    }

                    <div style={{ display: 'flex', marginTop: 50, }}>

                        <div style={{ marginRight: 20, width: '90%' }} >
                            <span className="form__form-group-label" > El paciente es Enrolado en el Estudio Clínico </span>
                        </div>
                        <div className="form__form-group-field"  >

                            <Field
                                name="enroled"
                                component={renderRadioButtonField}
                                label="Sí"
                                radioValue={"Sí"}
                                onChange={(e) => {
                                    this.handlerEnrolado(e);
                                }}
                            />
                            <Field
                                name="enroled"
                                component={renderRadioButtonField}
                                label="No"
                                radioValue={"No"}
                                onChange={(e) => {
                                    this.handlerEnrolado(e);
                                }}
                            />
                            {this.state.enrolado === "Sí" ?

                                <div className="form__form-group-field" >
                                    <span className="form__form-group-label" style={{ marginRight: 20 }}> Id Paciente</span>
                                    <input
                                        name="product-text"
                                        component={renderField}
                                        type="text"
                                        style={{ width: '30%', }}
                                        value={this.props.id_paciente}
                                    />
                                </div>
                                : null}
                        </div>
                    </div>

                    <Button
                        style={{ marginTop: 20 }}
                        color="primary"
                        onClick={() => {
                            this.saveCriterio();
                        }}>
                        Guardar
                    </Button>
                </div>
                {this.state.openAlert ?
                    <Modal
                        color={this.state.modalAlert.color}
                        title={this.state.modalAlert.title}
                        message={this.state.modalAlert.message}
                        modal={this.state.openAlert}
                        toggle={() => { this.setState({ openAlert: !this.state.openAlert }) }}
                        onOk={() => { this.setState({ openAlert: !this.state.openAlert }) }}
                    /> : null}
            </Col>
        );
    }
}

export default reduxForm({
    form: `criteria-form`, // a unique identifier for this form
})(withTranslation('common')(Criteria));